import { FC } from 'react';

import { LinkWithTitle } from '@/components/links';
import { AnchorWithTitle } from '@/components/links/anchor';

import Social from './Social';

import { container } from '@/styles/components/footer.module.scss';

const Footer: FC = () => {
  return (
    <footer className={container}>
      <div className="col-xxs-12">
        <Social />
        <div className='h-4' />
        <p>
          <AnchorWithTitle href="tel:18137428178">
            +1 (813) 742-8178
          </AnchorWithTitle>
        </p>
        <div className="business-info">
          <p className="business-name">
            <AnchorWithTitle
              href="https://maps.app.goo.gl/hrPUJnyrtKpE68i5A"
              target="_blank"
              rel="noopener noreferrer"
            >
              Tampa Bay Boating Adventures &middot; 801
              Severn Ave, Tampa, FL 33606
            </AnchorWithTitle>
          </p>
        </div>
        <p>
          &copy; 2024 Tampa Bay Boating Adventures &middot;
          All Rights Reserved. &middot;
          <LinkWithTitle to="/privacy">
            Privacy Policy
          </LinkWithTitle>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
